module.exports = __webpack_public_path__ + "fa-brands-400.592643a83b8541edc520.eot";


//////////////////
// WEBPACK FOOTER
// C:/ETT/Progetti/JumpvNext/Angular/AgentiWebUI/AgentiWebConqordOil.Web.UI/src/assets/fonts/fontawesome/fa-brands-400.eot
// module id = ../../../../../src/assets/fonts/fontawesome/fa-brands-400.eot
// module chunks = main